/* ============================================================
   MB PREZZI — pagina listino servizi di tinteggiatura
   Stima rapida al metro quadro + barra CTA appiccicosa su mobile.
   Nessun backslash in questo file, per convenzione.
   ============================================================ */

(function () {
  function euro(n) {
    return '€' + Math.round(n).toLocaleString('it-IT');
  }

  function initStima(root) {
    var box = root.querySelector('[data-stima]');
    if (!box) return;
    if (box.dataset.mbReady === '1') return;
    box.dataset.mbReady = '1';

    var campoMq = box.querySelector('[data-stima-mq]');
    var pillole = Array.prototype.slice.call(box.querySelectorAll('[data-stima-tipo]'));
    var esito = box.querySelector('[data-stima-esito]');
    var cifra = box.querySelector('[data-stima-cifra]');
    var nota = box.querySelector('[data-stima-nota]');
    var prezzo = 0;
    var etichetta = '';

    function calcola() {
      var mq = parseFloat(campoMq.value);
      if (!mq || mq <= 0 || !prezzo) {
        esito.hidden = true;
        return;
      }
      var minimo = mq * prezzo;
      var massimo = minimo * 1.35;
      cifra.textContent = euro(minimo) + ' – ' + euro(massimo);
      nota.textContent = etichetta + ' su ' + mq + ' m² di superficie da trattare.';
      esito.hidden = false;
    }

    pillole.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pillole.forEach(function (altra) { altra.classList.remove('is-active'); });
        pill.classList.add('is-active');
        prezzo = parseFloat(pill.dataset.stimaTipo) || 0;
        etichetta = pill.dataset.stimaNome || '';
        calcola();
      });
    });

    campoMq.addEventListener('input', calcola);

    if (pillole.length) pillole[0].click();
  }

  function initBarra(root) {
    var barra = root.querySelector('[data-prezzi-barra]');
    var ancora = root.querySelector('[data-prezzi-fine]');
    if (!barra || !ancora) return;
    if (barra.dataset.mbReady === '1') return;
    barra.dataset.mbReady = '1';

    if (!('IntersectionObserver' in window)) {
      barra.classList.add('is-visible');
      return;
    }

    var primo = root.querySelector('[data-prezzi-hero]');
    if (primo) {
      new IntersectionObserver(function (voci) {
        voci.forEach(function (v) {
          barra.classList.toggle('is-visible', !v.isIntersecting);
        });
      }, { threshold: 0 }).observe(primo);
    }

    new IntersectionObserver(function (voci) {
      voci.forEach(function (v) {
        if (v.isIntersecting) barra.classList.remove('is-visible');
      });
    }, { threshold: 0.2 }).observe(ancora);
  }

  function avvia() {
    var radici = Array.prototype.slice.call(document.querySelectorAll('[data-prezzi-root]'));
    radici.forEach(function (root) {
      initStima(root);
      initBarra(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', avvia);
  } else {
    avvia();
  }

  document.addEventListener('shopify:section:load', avvia);
})();
